import { React, useEffect } from "react";
import deliveryresi_photo from "../../assets/images/deliveryresi_photo.png";
import CommonTitle from "../common/DeliveryCommonTitle";
import { useDeliverySession } from "../../hooks/useDeliverySession"; // Adjust the import path
import { useTranslation } from "react-i18next";

const ShippingLabelScreen = ({ onBack, onNext, residentDetails }) => {
  const { session, removeDelivery } = useDeliverySession();
  const { t } = useTranslation();

  useEffect(() => {
    console.log("Current session in ShippingLabelScreen:", session); // Debug session state
    console.log("Resident Details:", residentDetails); // Debug resident details
  }, [session]); // Re-run when session changes

  const handleBack = () => {
    const residentId = residentDetails?.resident_id;
    if (!session?.deliveries?.length || !residentId) {
      console.warn(
        "No deliveries or residentId undefined, skipping removal. ResidentId:",
        residentId,
        "Session:",
        session
      );
      onBack();
      return;
    }

    // Find the index of the delivery to remove based on resident_id
    const existingIndex = session.deliveries.findIndex(
      (d) => d.resident_id === residentId
    );
    console.log(
      "ONBACK: ResidentId:",
      residentId,
      "Existing Index:",
      existingIndex,
      "Session Deliveries:",
      session.deliveries.map((d) => ({ resident_id: d.resident_id })) // Log only resident_ids for clarity
    );

    // Check if the delivery exists and has no captured images
    const delivery = session.deliveries[existingIndex];
    const hasNoImages =
      existingIndex !== -1 &&
      (!delivery?.captured_images?.links ||
        delivery?.captured_images?.links.length === 0);
    console.log(
      "Has No Images Check:",
      hasNoImages,
      "Captured Images:",
      delivery?.captured_images?.links
    );

    if (hasNoImages) {
      console.log(
        `Removing delivery with resident_id: ${residentId} at index ${existingIndex}`
      );
      removeDelivery(residentId);
    } else {
      console.log(
        "No matching delivery or images exist, skipping removal. ExistingIndex:",
        existingIndex,
        "Captured Images:",
        delivery?.captured_images?.links
      );
    }

    onBack();
  };

  return (
    <div className="w-full min-h-screen px-4 sm:px-6 py-6 relative">
      <CommonTitle showTitle={false} showBack={false} />
      <div className="flex items-center justify-center pt-5 px-4">
        <div className="bg-white rounded-xl shadow-md p-6 w-full max-w-md space-y-4">
          {/* Image */}
          <div className="flex justify-center items-center mb-6">
            <img
              src={deliveryresi_photo}
              alt="Take a Picture"
              className="max-w-xs w-64"
            />
          </div>

          {/* Message */}
          <div className="flex items-center justify-center ">
            <p className="text-lg font-medium text-gray-600 text-center">
              {t("pleaseTakePictureOfShippingLabel")}
            </p>
          </div>

          {/* Proceed Button */}
          <button
            className="w-full bg-blue-500 hover:bg-blue-600 text-white text-lg font-semibold py-3 rounded-md transition"
            onClick={onNext}
          >
            {t("proceed")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShippingLabelScreen;
